import React from "react";

import { Table } from 'react-bootstrap';

const PracticeFlags = (props) => {
    const has_pcps = props.practice.has_pcps ? 'Yes' : 'No';
    const has_acps  = props.practice.has_acps ? 'Yes' : 'No';
    const has_providers_accepting_new_patients = props.practice.has_providers_accepting_new_patients ? 'Yes' : 'No';
    const has_bookable_providers = props.practice.has_bookable_providers ? 'Yes' : 'No';
    const has_online_bookable_providers = props.practice.has_online_bookable_providers ? 'Yes' : 'No';
    const has_online_rescheduling_available  = props.practice.has_online_rescheduling_available ? 'Yes' : 'No';
    const has_telehealth_available  = props.practice.has_telehealth_available ? 'Yes' : 'No';

    return  (
        <Table bordered>
            <tbody>
                <tr>
                    <td>Has PCPs?</td>
                    <td><strong>{has_pcps}</strong></td>
                </tr>
                <tr>
                    <td>Has ACPs?</td>
                    <td><strong>{has_acps}</strong></td>
                </tr>
                <tr>
                    <td>Is accepting new patients?</td>
                    <td><strong>{has_providers_accepting_new_patients}</strong></td>
                </tr>
                <tr>
                    <td>Has bookable providers?</td>
                    <td><strong>{has_bookable_providers}</strong></td>
                </tr>
                <tr>
                    <td>Has online schedulable providers?</td>
                    <td><strong>{has_online_bookable_providers}</strong></td>
                </tr>
                <tr>
                    <td>Has online reschedulable providers?</td>
                    <td><strong>{has_online_rescheduling_available}</strong></td>
                </tr>
                <tr>
                    <td>Is Telehealth Available?</td>
                    <td><strong>{has_telehealth_available}</strong></td>
                </tr>
            </tbody>
        </Table>
    );
}

export default PracticeFlags;